'use strict'

var convert = require('unist-util-is/convert')

module.exports = convert('comment')
